import { useFormikContext } from 'formik'

interface iTextInputProps{
    name:string,
    text: string,
    placeholder?:string,
    type?: string
}


export default function TextInput({name, text, ...props}:iTextInputProps) {

    const {setFieldValue, setFieldTouched, values, errors, touched} = useFormikContext<any>()

    return (
        <div
            className="duration-300 w-full"
        >
            <label className='flex flex-row text-left justify-between font-medium text-graphite_x2' htmlFor={name}
            >
                {text}
                {(errors[name] && touched[name]) && <span className="w-2 h-2 bg-error rounded-full inline-block"/>}
            </label>

            <input
                {...props}
                name={name}
                className="bg-secondary2 border-none block w-full py-4 px-3 rounded-0.3 mt-0.3 outline-none focus:bg-primary focus:text-light_col"
                onChange={({target})=>{setFieldValue(name, target.value)}}
                onBlur={()=>{setFieldTouched(name)}}
                value={values[name]}
            />
        </div>
    )
}
